import * as React from "react";
const SvgTestGeneral = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14.7834 20H9.23678V8.90667H3.37012V4H20.6288V8.90667H14.7834V20Z", fill: "white" }));
export default SvgTestGeneral;
